import React, { useEffect, useState } from "react";
import Notification from "../../../components/Notification";
import MensagemListaVazia from "../../../components/Mensagem/MensagemListaVazia";
import Table from "../../../components/Table/Table";
import Scroll from "../../../components/InfiniteScroll/Scroll";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { withStyles } from "@material-ui/core";
import { pageConfiguracoes } from "../../../utils/getPageTitle";
import HeaderConfiguracoes from "../../../components/Header/HeaderConfiguracoes";
import { findAllExameDasaTipo } from "../../../services/ExamesService";
import { columns } from "./Constants";
import ModalExameSelecionado from "./Components/ModalExameSelecionado";
import { inject } from "mobx-react";

const ExamesDasa = ({ classes, exameStore }) => {
  const [exames, setExames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [last, setLast] = useState(false);
  const [openModalExame, setOpenModalExame] = useState(false);
  const [exameSelecionado, setExameSelecionado] = useState(null);
  const [pageableDTO, setPageableDTO] = useState({
    pageSize: 30,
    pageNumber: 0,
    sortDir: "ASC",
    sortField: "descricao",
  });

  useEffect(() => {
    loadExames({ isClear: true });
    
  }, [pageableDTO.sortDir]);

  const loadExames = async ({ isClear, isClearSearch }) => {
    if (loading) return;
    try {
      setLoading(true);
      const currentPage = isClear ? 0 : pageableDTO?.pageNumber;
      const variables = {
        pageableDto: {
          ...pageableDTO,
          pageNumber: currentPage,
        },
        search: isClearSearch ? "" : search,
      };
      const response = await findAllExameDasaTipo(variables);
      const { content, last } = response?.data?.data?.findAllExameDasaTipo;
      const examesAtualizados = isClear ? content : [...exames, ...content];
      setExames(examesAtualizados);
      setLast(last);
      setPageableDTO({
        ...pageableDTO,
        pageNumber: currentPage + 1,
      });
    } catch (error) {
      exameStore.openNotification("Erro ao carregar exames!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleClickSearch = () => {
    setPageableDTO({ ...pageableDTO, pageNumber: 0 });
    loadExames({ isClear: true });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && search.length >= 3) {
      handleClickSearch();
    }
  };

  const handleClickExame = (exame) => {
    setExameSelecionado(exame);
    setOpenModalExame(true);
  };

  const handleClickOrdenar = (e) => {
    setPageableDTO({
      ...pageableDTO,
      sortDir: pageableDTO.sortDir === "ASC" ? "DESC" : "ASC",
      pageNumber: 0,
    });
  };

  const handleClickClear = () => {
    setSearch("");
    loadExames({ isClear: true, isClearSearch: true });
  };

  const { notification, closeNotification } = exameStore;
  const { isOpen, message, variant } = notification;
  return (
    <div className={classes.container}>
      <PageTitle title={pageConfiguracoes("Exames Dasa")} />
      <HeaderConfiguracoes
        idPrefix="cfg-eda"
        showSearch
        placeholderSearch="Pesquisa por descrição"
        handleClickSearch={handleClickSearch}
        handleClickClear={handleClickClear}
        onChangeSearch={(e) => setSearch(e?.target?.value)}
        onKeypressSearch={handleKeyPress}
        valueSearch={search}
      ></HeaderConfiguracoes>
      <div className={classes.tableContainer}>
        <Scroll
          loadMore={() => loadExames({ isClear: false })}
          hasMore={!last}
          pageStart={0}
          initialLoad={false}
          className={classes.scrollContainer}
          isLoading={loading}
        >
          <Table
            dados={exames}
            columns={columns}
            clickable={true}
            ordenarTabela={{
              sortField: pageableDTO.sortField,
              sortDir: pageableDTO.sortDir,
            }}
            comOrdenacao
            handleClickOrdenar={handleClickOrdenar}
            getDadosRow={handleClickExame}
          />
          {exames?.length === 0 && !loading && (
            <div className={classes.notFoundContainer}>
              <MensagemListaVazia />
            </div>
          )}
        </Scroll>
      </div>

      {openModalExame && (
        <ModalExameSelecionado
          open={openModalExame}
          handleClose={() => setOpenModalExame(false)}
          exameSelecionado={exameSelecionado}
        />
      )}
      <Notification
        close={closeNotification}
        reset={closeNotification}
        isOpen={isOpen}
        variant={variant}
        message={message}
      />
    </div>
  );
};

const styles = (theme) => ({
  container: {
    padding: "0 20px",
  },
  tableContainer: {
    marginTop: "20px",
    height: "calc(100vh - 185px)",
  },
  scrollContainer: {
    height: "100%",
  },
  notFoundContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
});

const ExamesDasaWithStyles = withStyles(styles)(ExamesDasa);
export default inject("exameStore")(ExamesDasaWithStyles);
